import React from 'react';
import Select from 'react-select';

import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import { simpleNumberValidator } from '@common/react/utils/validationHelpers';
import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';
import useRequest from '@common/react/hooks/useRequest';
import FormikField from '@common/react/components/Forms/FormikField/FormikField';

import {
	emailValidator,
	simpleNumberZeroValidator,
	simpleStringFirstNameValidator,
	simpleStringReviewValidator,
	simpleStringValidator,
} from '@app/utils/validationHelpersForm';
import SubmitButton from '@app/components/UI/SubmitButton/SubmitButton';

enum ReviewType {
	Book = 0,
	Speaking = 1
}

const optionsBooks = [
	{
		label: 'Lorem',
		value: 1,
	},
	{
		label: 'ipsum',
		value: 2,
	},
	{
		label: 'dolor',
		value: 3,
	},
];

interface ReviewInquiry {
	name: string;
	lastName: string;
	email: string;
	bookName: number;
	reviewType: ReviewType;
	text: string;
}

const initialValuesReviewInquiry: ReviewInquiry = {
	name: '',
	lastName: '',
	email: '',
	bookName: 0,
	reviewType: ReviewType.Book,
	text: '',
};

const ReviewInquiry = Yup.object().shape({
	name: simpleStringFirstNameValidator,
	lastName: simpleStringValidator,
	email: emailValidator,
	reviewType: simpleNumberValidator,
	bookName: simpleNumberZeroValidator,
	text: simpleStringReviewValidator,
});

const ReviewForm: React.FC = () => {
	const [message, setMessage] = React.useState('');
	const [error, setError] = React.useState('');
	const [loading, setLoading] = React.useState(false);
	const [confirm, setConfirm] = React.useState(false);
	const request = useRequest();

	const handleSubmitReviewInquiry = (values, formikHelpers) => {
		setError('');
		setMessage('');
		setLoading(true);

		request('review', values)
			.then(() => {
				setTimeout(() => {
					setMessage('Successfully send.');
					formikHelpers.resetForm({ values: initialValuesReviewInquiry });
				}, 0);
				setTimeout(() => setMessage(''), 10000);
			})
			.catch((e) => {
				setError('Something went wrong');
				setTimeout(() => setLoading(false), 300);
				setTimeout(() => setError(''), 10000);
			})
			.finally(() => {
				setTimeout(() => setLoading(false), 300);
			});
	};

	return (
		<Formik<ReviewInquiry>
			initialValues={initialValuesReviewInquiry}
			onSubmit={handleSubmitReviewInquiry}
			validationSchema={ReviewInquiry}
		>
			{
				(formikBag) => {
					return <Form>
						<div className="row">
							<FormikField
								title=""
								containerClassName="form-group col-sm-6"
								fieldName="name"
								inputProps={{
									placeholder: 'First Name',
								}}
							/>
							<FormikField
								title=""
								containerClassName="form-group col-sm-6"
								fieldName="lastName"
								inputProps={{
									placeholder: 'Last Name',
								}}
							/>
							<FormikField
								title=""
								containerClassName="form-group col-sm-6"
								fieldName="email"
								inputProps={{
									placeholder: 'Email',
								}}
							/>
							{formikBag.values.reviewType === 0 && (<FormikField
								title=""
								containerClassName="form-group col-sm-6 select-validation"
								fieldName="bookName"
								render={() => <Select<any>
									placeholder="Select"
									className="select form-control"
									styles={{
										control: (style) => ({ ...style, padding: '15px 28px', borderRadius: 10 }),
										valueContainer: (style) => ({ ...style, padding: '0 5px 0 0' }),
										input: (style) => ({ ...style, margin: '1px 2px 1px 0' }),
									}}
									theme={(theme) => ({
										...theme,
										colors: {
											...theme.colors,
											primary25: 'rgba(93, 68, 147, 0.3)',
											primary: '#5d4493',
										},
									})}
									components={{
										IndicatorSeparator: () => null,
										DropdownIndicator: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="11" viewBox="0 0 18 11" fill="none">
											<path
												d="M8.5253 7.75521C8.16664 7.7017 2.38479 2.94377 1.11833 1.5967C0.637539 1.10652 -0.22286 1.77619 0.257931
												2.26636C2.63444 4.97811 5.19085 7.61234 7.6573 10.2853C7.8762 10.4899 8.29846 10.557 8.5253 10.3596C9.00245
												9.90488 9.78806 9.29827 10.2652 8.84358C13.0303 6.5561 15.2679 4.21601 17.5717 1.57939C17.9824 1.10353 17.1498
												0.366481 16.6726 0.821174C14.0042 3.45735 8.88396 7.80872 8.5253 7.75521Z"
												fill="#352557"
											/>
										</svg>,
									}}
									options={optionsBooks}
									onChange={(e) => formikBag.values.bookName = e.value}
								/>}
							/>)}
						</div>
						<div className="row">
							<div role="group" className="col-sm-6 radio-group">
								<label className="h4">
									<input
										name="reviewType"
										type="radio"
										value={ReviewType.Book}
										checked={formikBag.values.reviewType === ReviewType.Book}
										onChange={(e) => {
											formikBag.setFieldValue('reviewType', ReviewType.Book);
										}}
									/>
									<span />
									Book Review
								</label>
								<label className="h4">
									<input
										name="reviewType"
										type="radio"
										value={ReviewType.Speaking}
										checked={formikBag.values.reviewType === ReviewType.Speaking}
										onChange={(e) => {
											formikBag.setFieldValue('reviewType', ReviewType.Speaking);
											formikBag.setFieldValue('bookName', 0);
										}}
									/>
									<span />
									Speaking Review
								</label>
							</div>
						</div>
						<FormikField
							title=""
							containerClassName="form-group textarea-validation"
							fieldName="text"
							render={({ field }) => <div>
								<textarea
									{...field}
									placeholder="Review"
									className="form-control"
								/>
								<ImageLazy
									alt="cat"
									width={113}
									height={175}
									className="cat-pen"
									src="/images/CatPencil.png"
								/>
							</div>}
						/>
						<div className="confirm-checkbox">
							<input
								type="checkbox"
								name="senderType"
								checked={confirm}
								onChange={(e) => e.target.value}
							/>
							<label className="h4" htmlFor="checked" onClick={() => setConfirm(!confirm)}>
								By checking this box, you are authorizing Dr. Mary to use your review and name on all
								media channels.
							</label>
							<div className="svg-container">
								<svg xmlns="http://www.w3.org/2000/svg" width="13" height="9" viewBox="0 0 13 9" fill="none">
									<path
										d="M1.98682 4.26856C2.38168 4.59133 2.80926 4.91737 3.2093 5.20896C3.62689 5.51334 4.02439 5.78737 4.33827
										5.9896C4.49458 6.09031 4.63486 6.17626 4.74892 6.23996C4.80554 6.27157 4.86139 6.30091 4.9129 6.32452C4.94999
										6.34152 5.03294 6.37886 5.12807 6.39305C5.26386 6.41331 5.37646 6.37714 5.41323 6.36491C5.46578 6.34744 5.51264
										6.32544 5.54826 6.30722C5.62074 6.27017 5.69928 6.22154 5.77669 6.17024C5.93426 6.06579 6.13507 5.91808 6.36373
										5.7416C6.8235 5.38673 7.4264 4.89178 8.08195 4.33416C9.21129 3.37354 10.5131 2.21317 11.5314 1.23893C9.88031
										3.10108 8.25072 4.76966 6.2783 6.40141L6.26363 6.41354L6.24989 6.42664C6.07703 6.59136 5.84324 6.78815 5.59062
										7.00046L5.58135 7.00825C5.36607 7.18918 5.13699 7.38172 4.94811 7.55639C4.94252 7.55476 4.9368 7.55274 4.93123
										7.55033C4.92522 7.54773 4.92083 7.54531 4.91788 7.54351C3.49222 5.99821 3.0607 5.5024 2.16466 4.47288C2.1074
										4.40709 2.04825 4.33912 1.98682 4.26856Z"
										fill="#80D33F"
										stroke="white"
									/>
								</svg>
							</div>
						</div>
						<SubmitButton
							loading={loading}
							error={error}
							message={message}
							formikBag={formikBag}
							textButton="Send message"
							textDone="Thank you for your speaking request. We will reach out to you shortly!"
							disabled={!confirm}
						/>
					</Form>;
				}
			}
		</Formik>
	);
};

export default ReviewForm;
